// extracted by mini-css-extract-plugin
export default {"iconMenuBtn":"REFRESH_ZAMOWIENIA_BTN_iconMenuBtn__DnpMM","iconMenuBtnDisabled":"REFRESH_ZAMOWIENIA_BTN_iconMenuBtnDisabled__898Ua"};